import { t } from '../../i18n';

interface SsoLoginViewProps {
  provider: string;
  onLogin(): void;
}

export function SsoLoginView({ provider, onLogin }: SsoLoginViewProps) {
  const label = t('authSsoButton').replace('{provider}', provider.toUpperCase());

  return (
    <div className="input-bar">
      <button className="sso-login-btn" onClick={onLogin}>{label}</button>
    </div>
  );
}

export function SsoPendingView() {
  return (
    <div className="input-bar">
      <div className="sso-pending-msg">
        <span className="upload-spinner" />
        {t('authSsoPending')}
      </div>
    </div>
  );
}
